import React, { useState } from 'react'
import { Popover, ArrowContainer } from 'react-tiny-popover'

import InfoIcon from 'react-icons/lib/fa/info-circle'

import './styles'

ARROW_SIZE = 8
ARROW_COLOR = '#F0F0F0'

export default Info = ({ children }) ->
  return null unless children

  [isOpen, setIsOpen] = useState false
  [isPreview, setIsPreview] = useState false

  onClosePopover = ->
    setIsOpen false
    setIsPreview false

  onTogglePopover = -> setIsOpen (prevState) -> not prevState

  popoverContent = ({ position, childRect, popoverRect }) ->
    <ArrowContainer
      arrowSize={ARROW_SIZE}
      arrowColor={ARROW_COLOR}
      className='InfoPopover'
      {...{ position, childRect, popoverRect }}
    >
      <div className="content">
        {children}
      </div>
    </ArrowContainer>

  <div
    className="Info"
    onMouseEnter={() => setIsPreview(true)}
    onMouseLeave={() => setIsPreview(false)}
  >
    <Popover
      isOpen={isPreview or isOpen}
      onClickOutside={onClosePopover}
      positions={['left', 'bottom', 'right']}
      padding={4}
      content={(content) -> popoverContent content}
    >
      <div
        className="icon-container"
        onClick={onTogglePopover}
      >
        <InfoIcon className="info-icon" />
      </div>
    </Popover>
  </div>
